import { Component, ContentChildren, Host, Optional, QueryList, SkipSelf } from '@angular/core';
import { AutocompleteOptionDirective } from '../../directives/autocomplete-option.directive';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-autocomplete-option-group',
  imports: [NgTemplateOutlet],
  templateUrl: './autocomplete-option-group.component.html',
})
export class AutocompleteOptionGroupComponent {
  @ContentChildren(AutocompleteOptionDirective) options?: QueryList<AutocompleteOptionDirective>;

  constructor(@Optional() @Host() @SkipSelf() private parent: AutocompleteComponent) {}

  get hasOptions() {
    return !!this.options?.length;
  }

  setOptionActive(option: AutocompleteOptionDirective) {
    this.parent.setActive(option);
  }

  selectOption(option: AutocompleteOptionDirective) {
    this.parent.selectOption(option);
  }
}
